/* ==========================================================================
  main.js
========================================================================== */

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 890,
    menu: dropdown_menus[i]
  });
}

/**
 * Init mobile menu
 */
component_mobile_menu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    objectFitPolyfill();
    e.target.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Init lightbox
 */
document.querySelectorAll('.lightbox').forEach(function (elem) {
  elem.dataset.fslightbox = true;
});

/**
 * Init home hero header slider
 */
if ( document.querySelectorAll('.hero__slider').length ) {

  var slider = tns({
    container             : '.hero__slider',
    items                 : 1,
    autoplay              : true,
    autoplayTimeout       : 3000,
    autoplayButtonOutput  : false,
    speed                 : 500,
    controls              : false,
    nav                   : true,
    navPosition           : 'bottom'
  });

}

/**
 * Init featured metiers slider
 */
var elem = document.querySelectorAll('.slider-metiers__slider--active');

if ( elem.length ) {

  var responsive = {
    560: {
      items    : 2,
      gutter   : 10,
    },
    768: {
      items    : 2,
      nav      : false,
      controls : true,
    },
    1024: {
      items    : 3,
    },
    1320: {
      items    : 4,
    },
    1560: {
      items    : 5,
    }
  };

  // check if it's a mini slider
  if ( elem[0].classList.contains('slider-metiers__slider--mini') ) {
    responsive = {
      1024: {
        items    : 1,
        nav      : true,
        controls : true
      }
    };
  }

  var sliderMetier = tns({
    container             : '.slider-metiers__slider--active',
    items                 : 1,
    autoplay              : true,
    autoplayTimeout       : 3000,
    autoplayButtonOutput  : false,
    speed                 : 500,
    prevButton            : '#slider-metiers-prev',
    nextButton            : '#slider-metiers-next',
    navPosition           : 'bottom',
    controls              : false,
    // disable               : true,
    responsive            : responsive
  });

}

function scrollToTop() {
  window.scroll({top: 0, left: 0, behavior: 'smooth'});
}

/**
 * FAQ accordion with Houdinijs plugin
 */
if (document.querySelectorAll('.faq-container').length) {

  var accordion = new Houdini('[data-houdini-group]', {
    isAccordion: true,
    collapseOthers: true,
    icon: false
  });

}

/**
 * Init metier single tabs with TabbyJS
 * @source : https://github.com/cferdinandi/tabby
 */
if ( document.querySelectorAll('#nav-tab').length ) {
  var tabs = new Tabby('[data-tabs]');
  tabs.toggle('#formations');
}

/**
 * Init ANEFA slider
 */
var sliderAnefa;

if ( document.querySelectorAll('.anefa-slider--active').length ) {

  sliderAnefa = tns({
    container             : '.anefa-slider--active',
    items                 : 1,
    autoplay              : true,
    autoplayTimeout       : 3000,
    autoplayButtonOutput  : false,
    speed                 : 500,
    nav                   : true,
    navPosition           : 'bottom',
    controls              : false,
  });

}

/**
 * Youtube embed poster frame reveal
 * Hint : Need jQuery
 * @source: https://codepen.io/pixelthing/pen/zGZKaQ
 */
jQuery(document).on('click ','.js-videoPoster',function(ev) {
  // BUG: not workink on mobile device
  ev.preventDefault();
  // retrieve current poster & wrapper
  var $poster = jQuery(this);
  var $wrapper = $poster.closest('.js-videoWrapper');
  // play video
  var $iframe = $wrapper.find('.js-videoIframe');
  var src = $iframe.data('src');
  // hide poster
  $wrapper.addClass('videoWrapperActive');
  // add iframe src in, starting the video
  $iframe.prop('src',src);
  // $iframe.attr('src',src);
  console.log($iframe);
  // stop slider
  if(sliderAnefa) {
    sliderAnefa.pause();
  }

});

/**
 * jQuery globals functions
 */
jQuery(document).ready(function($){

  /**
   * Attach Select2JS plugin to <select> element with select2js class
   * If custom class "slect2js--alt" is finded, change select2js containerCssClass option (pink to blue arrow)
   */

    var $select = $('.select2js');
    var cssClass = 'select2-selection--pink-arrow';

    if($select.hasClass('select2js--alt')) {
      cssClass = 'select2-selection--blue-arrow';
    }

    $('.select2js').select2({
      minimumResultsForSearch: -1,
      width: '100%',
      containerCssClass: cssClass
    });

});

/**
 * Mobile (890px) : Sticky primary menu on scroll
 */
let scrollpos = window.scrollY;
let windowWidth = window.innerWidth;
const header = document.querySelector(".site-header");
const header_height = header.offsetHeight;
const add_class_on_scroll = () => header.classList.add("site-header--sticky");
const remove_class_on_scroll = () => header.classList.remove("site-header--sticky");

function stickyMenu() {
  scrollpos   = window.scrollY;
  windowWidth = window.innerWidth;

  if ( ( scrollpos >= header_height ) && ( window.innerWidth < 890 ) ) {
    add_class_on_scroll();
  } else {
    remove_class_on_scroll();
  }

}

window.addEventListener('scroll', function() {
  stickyMenu();
});

stickyMenu();
